import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import ComposedBonusMessage from '../ComposedBonusMessage/ComposedBonusMessage';
import SeeDetailsLink from '../SeeDetailsLink/SeeDetailsLink';

const DepositPartAsBonus: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { bonusMax, bonusPercent } = preCashinInfo as PreCashinInfo;

  const amount = bonusPercent ? (bonusMax * 100.0) / bonusPercent : 0.0;

  return (
    <>
      <ComposedBonusMessage amount={amount} bonus={bonusMax} isFirst={true} />
      <SeeDetailsLink />
    </>
  );
};

export default DepositPartAsBonus;
